/**
 * Fires the callback whenever a click happens outside the node
 * @param {Object} node 
 * @param {Function} callback 
 */
export default function clickOutside(node, callback) {
	document.addEventListener('click', event => {
		if (node !== event.target && !node.contains(event.target)) {
			callback()
		}
	})
}


// WEBPACK FOOTER //
// ./scripts/helpers/click-outside.js